import messageService from '../../services/messageService'

const state = {
  messages: [],
  works: [],
  works_next_page: 0,
  works_loading: false
}

const getters = {
  messages: state => {
    return state.messages
  },
  works: state => {
    return state.works
  }
}

const actions = {
  getMessages({ commit }, page) {
    messageService.fetchMessages(page)
    .then(works => {
      commit('setWorks', works.results)
      commit('setWorksNextPage', works.next.split("=").at(-1))
    })
  },
  getMessage({commit}, msgId) {
    messageService.fetchMessage(msgId)
    .then(works => {
      commit('setWorks', works.results)
    })
  },
  addMessage({ commit }, message) {
    messageService.postMessage(message)
    .then(() => {
      commit('addMessage', message)
    })
  },
  deleteMessage( { commit }, msgId) {
    messageService.deleteMessage(msgId)
    commit('deleteMessage', msgId)
  }
}

const mutations = {
  setMessages (state, messages) {
    state.messages = messages
  },
  setWorks (state, works) {
    state.works = works
  },
  setWorksNextPage (state, works_next_page) {
    state.works_next_page = works_next_page
  },
  addWorks(state, page) {
    state.works_loading = true

    messageService.fetchMessages(page)
    .then(new_works => {
      // ... spread will push the items of the array
      state.works.push(...new_works.results)
      state.works_next_page = new_works.next.split("=").at(-1)

      state.works_loading = false
    })
  },
  deleteMessage(state, msgId) {
    state.messages = state.messages.filter(obj => obj.pk !== msgId)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}